var render = function render(){var _vm=this,_c=_vm._self._c;return _c('svg',{attrs:{"xmlns":"http://www.w3.org/2000/svg","width":_vm.size,"height":_vm.size,"viewBox":"0 0 32 32","fill":"none"}},[_c('path',{attrs:{"d":"M8 24V8H10V24H8ZM22.9 23.9L15.1 16.1L22.9 8.3L24.3333 9.73333L17.9667 16.1L24.3333 22.4667L22.9 23.9Z","fill":_vm.color,"fill-opacity":"0.38"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }